<template>
  <div class="error-list" :style="{height: listHeight}">
    <div class="passing-module-title red-title">
      异常信息
      <span class="title-info">总计{{ errInfo.totalCount }}</span>
      <span class="title-info title-info--green">处理{{ errInfo.dealCount }}</span>
    </div>
<!--    <div class="list-container" v-if="listHeight" v-loading="loading">-->
<!--      <el-empty v-show="!errInfo.data.length" description="当前车厢无异常"></el-empty>-->
<!--      <row-edit-form-->
<!--        v-show="errInfo.data.length"-->
<!--        v-for="item in errInfo.data"-->
<!--        detail-form-->
<!--        :key="item.id"-->
<!--        :column="formColumn"-->
<!--        :col-span="[8, 16]"-->
<!--        :data-list="item"-->
<!--        :label-style="{backgroundColor: '#E1F2FF'}"-->
<!--      >-->
<!--        <template #problemTypeLabel="{formData}">-->
<!--          <div class="info-content" :style="{color: Number(item.dealStatus) === 0 ? '#CC0000' : ''}">-->
<!--            {{ formData.problemTypeLabel }}-->
<!--          </div>-->
<!--        </template>-->
<!--        <template #menu>-->
<!--          <template v-if="Number(item.dealStatus) === 0">-->
<!--            <el-button v-has-permi="[`${permiStr}:error:delete`]" type="danger" plain @click="onDel(item)">删除</el-button>-->
<!--            <el-button v-has-permi="[`${permiStr}:error:handle`]" type="primary" plain @click="onHandle(item)">处理</el-button>-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            <el-button type="primary" plain @click="onHandle(item, 'view')">查看</el-button>-->
<!--          </template>-->
<!--        </template>-->
<!--      </row-edit-form>-->
<!--    </div>-->
    <avue-crud
      ref="crud"
      :option="option"
      :data="errInfo.data"
      :table-loading="loading"
    >
      <template #problemTypeLabel="{row}">
        <div class="info-content" :style="{color: Number(row.dealStatus) === 0 ? '#CC0000' : ''}">
          {{ row.problemTypeLabel }}
        </div>
      </template>
      <template #menu="{row}">
        <template v-if="Number(row.dealStatus) === 0">
          <el-button v-has-permi="[`${permiStr}:error:handle`]" type="text" @click="onHandle(row)">处理
          </el-button>
          <el-button v-has-permi="[`${permiStr}:error:delete`]" type="text" @click="onDel(row)">删除
          </el-button>
        </template>
        <template v-else>
          <el-button type="text" @click="onHandle(row, 'view')">查看</el-button>
        </template>
      </template>
    </avue-crud>
    <dialog-reset
      top='8vh'
      height="650px"
      width="1050px"
      zoomShow
      ask_Dialogdrag
      title="异常处理"
      :visible.sync="dialogVisible"
    >
      <handle-error
        :info="handleInfo"
        :visible.sync="dialogVisible"
        :view-type="viewType"
        @afterSubmit="afterHandleSubmit"></handle-error>
    </dialog-reset>
  </div>
</template>

<script>
import RowEditForm from "@/components/matrix/row-edit-form.vue";
import {
  deleteProblem,
  getProblemByTrainListDetailID,
} from "@/api/handover-inspection/passing-manage";
import _ from "lodash";
import DialogReset from "@/basic-common/components/DialogReset.vue";
import HandleError from "./handle-error.vue";

export default {
  name: "error-list",
  components: {HandleError, DialogReset, RowEditForm},
  props: {
    carriageInfo: Object, // 车厢信息
    permiStr: String,
  },
  data() {
    return {
      listHeight: 0,
      loading: false,
      errInfo: { // 异常信息
        totalCount: 0,
        dealCount: 0,
        data: []
      },
      formColumn: [ // 列表配置
        {label: '序号', field: 'problemSerial'},
        {
          label: '标记类型', field: 'flag',
          formatter: (row) => {
            return this.getFlagName(row.flag)
          }
        },
        {label: '异常类型', field: 'problemTypeLabel'},
        {label: '操作', field: 'menu'},
      ],
      option: {
        border: true,
        header: false,
        menu: false,
        align: 'center',
        selection: false,
        index: false,
        column: [
          {label: '序号', prop: 'problemSerial', width: 70},
          {
            label: '标记类型', prop: 'flag',
            formatter: (row) => {
              return this.getFlagName(row.flag)
            }
          },
          {label: '异常类型', prop: 'problemTypeLabel'},
          {label: '操作', prop: 'menu', width: 115},
        ]
      },
      debounceSearch: _.debounce(this.handleSearch, 300),
      dialogVisible: false, // 异常处理弹窗 visible
      viewType: '', // 弹窗类型
      handleInfo: {}, // 点击处理的异常信息
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initHeight()
      this.debounceSearch()
    })
  },
  methods: {
    initHeight() {
      const pageH = document.documentElement.clientHeight
      // const statisticsH = document.getElementsByClassName('error-statistics')[0].clientHeight // 异常信息统计高度
      const statisticsH = document.getElementsByClassName('passing-train-list')[0].clientHeight // 车厢列表高度
      const formH = document.getElementsByClassName('carriage-form')[0].clientHeight // 车节详情表单高度
      this.listHeight = ~~(pageH - statisticsH - formH - 50 - 60) + 'px' // 50 是弹窗 padding
      this.$refs.crud.tableHeight = ~~(pageH - statisticsH - formH - 80 - 60)
    },
    handleSearch() {
      if (!this.carriageInfo.id) return
      const params = {
        trainDetailId: this.carriageInfo.id
      }
      this.loading = true
      getProblemByTrainListDetailID(params).then(res => {
        if (res.code === 200) {
          this.errInfo = res.data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 删除
    onDel(info) {
      this.$modal.confirm('确定删除选中信息？').then(() => {
        this.loading = true
        deleteProblem({id: info.id}).then(res => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.$emit('handleDel')
          } else {
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    // 点击列表处理按钮
    onHandle(info, type = 'edit') {
      const obj = {A: 'leftPath', B: 'topPath', C: 'rightPath'}
      const key = obj[info.camera]
      const imgSrc = this.carriageInfo[key].original // 异常对应原图
      this.handleInfo = {...info, flagName: this.getFlagName(info.flag), imgSrc}
      this.dialogVisible = true
      this.viewType = type
    },
    // 处理后回调
    afterHandleSubmit() {
      this.dialogVisible = false
      this.$emit('after-handle')
    },
    getFlagName(flag) {
      const value = Number(flag)
      return value === 1 ? '人工标记' : value === 0 ? 'AI识别' : ''
    }
  },
}
</script>

<style scoped lang="scss">
.error-list {
  overflow: hidden;

  .passing-module-title {
    font-size: 20px;
  }

  .red-title {
    color: #CC0000 !important;
  }

  .title-info {
    margin-left: 20px;

    &--green {
      color: #43A047;
    }
  }

  .list-container {
    height: calc(100% - 30px);
    box-sizing: border-box;
    overflow-y: auto;
  }

  ::v-deep .el-table .el-table__header-wrapper th {
    font-size: 20px;
  }

  ::v-deep .el-table--mini {
    font-size: 20px !important;

    .el-table__cell {
      height: 45px;
    }

    .el-button--mini {
      font-size: 20px;
    }
  }
}
</style>
